import { Table, Flex, Text, Box } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

import ActionButtons from './ActionButtons.jsx';
import AutoExpandTextarea from './AutoExpandTextarea.jsx';
import styles from './NewGoalForm.module.css';
import TextField from '../../../shared/TextField/TextField.jsx';

const NewGoalForm = ({ newGoal, setNewGoal, onSave, onCancel, onKeyDown }) => {
  const { t } = useTranslation('goals');

  return (
    <Table.Row style={{ backgroundColor: 'var(--gray-2)' }}>
      <Table.Cell width="10px">
        <Flex
          align="center"
          justify="center"
          width="24px"
          height="24px"
          style={{
            borderRadius: '4px',
            color: 'var(--gray-9)',
            fontSize: '12px',
          }}
        >
          <i className="fa-solid fa-plus" style={{ color: 'var(--gray-9)' }} />
        </Flex>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell pl="2">
        <Flex direction="column" gap="2" width="100%">
          <Flex align="start" gap="2" width="100%">
            <AutoExpandTextarea
              value={newGoal.goal}
              onChange={e =>
                setNewGoal({
                  ...newGoal,
                  goal: e.target.value,
                })
              }
              onKeyDown={onKeyDown}
              placeholder={t('placeholder')}
              autoFocus
            />
            <Text size="1" mt="2">
              {t('year')}:
            </Text>
            <Box width="110px">
              <TextField
                type="number"
                value={newGoal.planYear}
                onChange={e =>
                  setNewGoal({
                    ...newGoal,
                    planYear:
                      parseInt(e.target.value, 10) || new Date().getFullYear(),
                  })
                }
                onKeyDown={onKeyDown}
                className={styles.yearInputField}
              />
            </Box>
          </Flex>
        </Flex>
      </Table.Cell>
      <Table.Cell>
        <ActionButtons
          isEditing={true}
          onSave={onSave}
          onCancel={onCancel}
          onEdit={() => {}}
          onCopy={() => {}}
          onDelete={() => {}}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default NewGoalForm;
